import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
export const getAmktBootstrap = mpacBaseUrl => fetchOk(mpacBaseUrl + "/rest/internal/frontend/bootstrap").then(response => response.json()).catch(_ => ({
  ldUserKey: 'ANY_USER'
}));